import React from 'react';
import './Blog.css'
import fahim from '../../images/blog-image/fahim.jpg'
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import npm from '../../images/blog-image/npm.png'
import npm1 from '../../images/blog-image/npm1.jpeg'
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import useTitle from '../../Hooks/useTitle';
import { FaXTwitter } from 'react-icons/fa6';
import resume from '../../images/blog-image/resume.png'
import code from '../../images/blog-image/code.jpeg'



import ReactPrint from 'react-to-print';
import { useRef } from 'react';



import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
} from "react-share";


import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import { useLanguage } from '../../context/LanguageContext';
SwiperCore.use([Autoplay, Pagination]);











const Blog5Details = () => {


    const shareUrl = window.location.href
    // console.log('Current Window Location: ', window.location)
    // console.log('Current Page URL: ', window.location.href)
    // console.log('Path Name: ', window.location.pathname)

    const { language } = useLanguage()

    const ref = useRef();

    window.scrollTo(0, 0);
    useTitle("Blog-Four Reasons Why Year Gaps Before Bachelor's Isn't End of Your Life");



    const postUrl = `https://fahim-faysal-portfolio.netlify.app/blog2`;
    const postTitle = "4 Reasons Why Year Gap In Study Isn't End of life";
    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${postUrl}`, '_blank');
    };
    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${postUrl}`, '_blank');
    };
    const shareOnLinkedIn = () => {
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`, '_blank');
    };




    return (
        <div className=' mt-12 lg:px-2 md:px-2 px-0 '>


            <div className='flex justify-center lg:flex-row flex-col mb-20 lg:px-0 md:px-8 px-2 lg:gap-x-3 lg:gap-y-0 gap-x-4 gap-y-20'>



                <div className=' print:hidden lg:block hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1  md:left-0 fixed top-[160px]'>
                    <div className=''>
                        <div className={`bg-base-100 border-r-4 border-gray-600   rounded-lg }`}>
                            <div className="avatar flex justify-center items-center">
                                <div className="mt-2  w-[105px] rounded-full">
                                    <img className='mx-auto' src={fahim} alt='fahim' />
                                </div>
                            </div>
                            <p className='-mt-1 text-white text-2xl font-bold text-center px-6 py-3'>FAHIM FAYSAL</p>
                            <p className='-mt-1 text-[16px] text-justify px-4'>I am a full-stack developer from Bangladesh and am available to work in office or remotely.</p>
                            <p className='mt-3 text-[16px] text-amber-500 text-justify px-4'>Expert In: <span className='text-white'>ReactJS, NodeJS, MongoDB, Redux, Firebase</span></p>
                            <div className='flex justify-center items-center gap-x-4 mt-4'>
                                <div className=''>
                                    <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                                        <BsGithub className='text-white text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                                        <BsLinkedin className='text-white text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                                    </a>
                                </div>
                                <div className=' '>
                                    <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                                        <BsInstagram className='text-white text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                                        <BsFacebook className='text-white text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                                    </a>
                                </div>
                            </div>
                            <Link to='/contact'>
                                <div className='w-full mt-3 mx-auto text-center cursor-pointer'>
                                    <button className=' text-lg w-full px-16 py-2 bg-rose-700 hover:bg-rose-800 rounded-sm text-white'>Hire Me</button>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>













                <div className='lg:ml-[355px] lg:w-6/12 w-full mx-auto bg-white screen:shadow-2xl print:shadow-none md:px-6 px-2 py-8 ml:0'>


                    <div>

                        <div ref={ref} className='bg-white text-black mt-6'>
                            <div>

                                {
                                    language === 'english' ?
                                        <h2 className='font-sans lg:text-4xl text-[27px] text-start font-bold text-black mb-3'>Four Reasons Why Year Gaps Before Bachelor's Isn't End of Your Life?</h2>
                                        :
                                        <h2 className='text-justify first-line:font-sans lg:text-[32px] md:text-[32px] text-[23px]  font-bold text-black mb-3'>চারটি কারণ কেন স্নাতকের আগে বছরের ব্যবধান আপনার জীবনের শেষ নয়?</h2>
                                }

                                <div>
                                    <img className='md:h-80 h-[245px] w-full my-8' src={visa} alt="BlogImage" />
                                </div>

                                {
                                    language === 'english' ?
                                        <>
                                            <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                                Let's say you dream of taking some time off after you finish high school to travel the world, meet new people and decide on your Bachelor’s specialization. Universities usually like students with some life experience, especially if they are able to show how a gap year has expanded their perspectives.But, besides polishing your CV, a gap year can be used to check out the country or city where you want to study – see how it suits you. And since you’re there, why not take some Pre-Bachelor’s courses? Pre-Bachelors are usually short and medium-term courses (2 months to a year) which help you prepare for your Bachelor’s admission. They will increase your chances of getting in a university, while at the same time give you the opportunity to start networking with teachers and other students. Sometimes, a gap-year is a result of circumstances.
                                            </p>
                                            <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                                Maybe your saving money for a Bachelor’s abroad, maybe you started a family earlier, or you have some other personal issues that prevent you from travelling immediately after high school. If you are in such a situation, you can still make the best out of a ‘forced’ gap year by pursuing an online Pre-Bachelor’s. It gives you flexibility and helps you keep contact with the academic world, so that when you are ready for a full-time Bachelor’s you are not completely disconnected from the student environment. If you’re the ambitious type of student who can’t imagine going to any other university than his top pick, you’ll be glad to know you are not alone.
                                            </p>
                                            <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                                Many prospective Bachelor’s students choose to invest a year in a complex Pre-Bachelor’s programme that will give them a competitive advantage when applying for a Bachelor’s. While this is more a preparatory year than a gap year, you can still make the best of it, because the curricula is more relaxed than during Bachelor’s studies. Opinions on gap years vary from person to person. Some say they are important to get practical life experiences and develop as an adult before doing Bachelor’s studies. Others prefer doing their Bachelor’s straightway because they want to graduate faster. In the end, it’s a matter of personal goals and ambitions, which are unique for every individual. If you think a gap year can help you grow, see the world and better prepare you for your future studies, go for it and don’t let anyone tell you otherwise!
                                            </p>
                                        </>
                                        :
                                        <>
                                            <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                                ধরা যাক আপনি হাইস্কুল শেষ করার পরে বিশ্ব ভ্রমণের জন্য, নতুন লোকের সাথে দেখা করতে এবং আপনার ব্যাচেলর স্পেশালাইজেশনের বিষয়ে সিদ্ধান্ত নেওয়ার জন্য কিছু সময় নেওয়ার স্বপ্ন দেখেন। বিশ্ববিদ্যালয়গুলি সাধারণত এমন ছাত্রদের পছন্দ করে যাদের জীবনের কিছু অভিজ্ঞতা আছে, বিশেষ করে যদি তারা দেখাতে পারে যে কীভাবে একটি গ্যাপ ইয়ার তাদের দৃষ্টিভঙ্গিকে প্রসারিত করেছে৷ কিন্তু, আপনার সিভি পালিশ করার পাশাপাশি, আপনি যে দেশে বা শহরটি পড়তে চান তা দেখতে একটি গ্যাপ ইয়ার ব্যবহার করা যেতে পারে৷ - দেখুন এটা আপনার জন্য কিভাবে উপযুক্ত. এবং যেহেতু আপনি সেখানে আছেন, কেন কিছু প্রাক-ব্যাচেলর কোর্স গ্রহণ করবেন না? প্রাক-ব্যাচেলর সাধারণত স্বল্প এবং মধ্য-মেয়াদী কোর্স (2 মাস থেকে এক বছর) যা আপনাকে আপনার ব্যাচেলর ভর্তির জন্য প্রস্তুত করতে সাহায্য করে। তারা আপনার বিশ্ববিদ্যালয়ে ভর্তি হওয়ার সম্ভাবনা বাড়িয়ে তুলবে, একই সাথে আপনাকে শিক্ষক এবং অন্যান্য শিক্ষার্থীদের সাথে নেটওয়ার্কিং শুরু করার সুযোগ দেবে। কখনও কখনও, একটি গ্যাপ-বছর পরিস্থিতির ফলাফল।
                                            </p>
                                            <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                                হতে পারে বিদেশে ব্যাচেলরের জন্য আপনার অর্থ সঞ্চয়, হতে পারে আপনি আগে একটি পরিবার শুরু করেছেন, বা আপনার অন্য কিছু ব্যক্তিগত সমস্যা রয়েছে যা আপনাকে উচ্চ বিদ্যালয়ের পরপরই ভ্রমণ করতে বাধা দেয়। আপনি যদি এমন পরিস্থিতিতে থাকেন তবে আপনি অনলাইন প্রি-ব্যাচেলর অনুসরণ করে একটি 'জোর করে' গ্যাপ ইয়ার থেকে সেরাটা বের করতে পারেন। এটি আপনাকে নমনীয়তা দেয় এবং আপনাকে একাডেমিক জগতের সাথে যোগাযোগ রাখতে সাহায্য করে, যাতে আপনি যখন পূর্ণ-সময়ের ব্যাচেলরের জন্য প্রস্তুত হন তখন আপনি ছাত্র পরিবেশ থেকে সম্পূর্ণভাবে সংযোগ বিচ্ছিন্ন না হন। আপনি যদি উচ্চাভিলাষী ধরণের ছাত্র হন যিনি তার সেরা বাছাই ছাড়া অন্য কোনও বিশ্ববিদ্যালয়ে যাওয়ার কল্পনা করতে পারেন না, আপনি জেনে খুশি হবেন যে আপনি একা নন।
                                            </p>
                                            <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                                অনেক সম্ভাব্য ব্যাচেলর শিক্ষার্থীরা একটি জটিল প্রাক-ব্যাচেলর প্রোগ্রামে এক বছর বিনিয়োগ করতে বেছে নেয় যা স্নাতকের জন্য আবেদন করার সময় তাদের একটি প্রতিযোগিতামূলক সুবিধা দেবে। যদিও এটি একটি ফাঁক বছরের তুলনায় একটি প্রস্তুতিমূলক বছর, আপনি এখনও এটির সেরাটি করতে পারেন, কারণ ব্যাচেলর অধ্যয়নের সময় পাঠ্যক্রমটি আরও শিথিল। ব্যবধান বছর সম্পর্কে মতামত ব্যক্তি থেকে ব্যক্তি পরিবর্তিত হয়। কেউ কেউ বলে যে তারা ব্যাচেলর অধ্যয়ন করার আগে বাস্তব জীবনের অভিজ্ঞতা অর্জন করা এবং একজন প্রাপ্তবয়স্ক হিসাবে বিকাশ করা গুরুত্বপূর্ণ। অন্যরা তাদের ব্যাচেলর সরাসরি করতে পছন্দ করে কারণ তারা দ্রুত স্নাতক হতে চায়। শেষ পর্যন্ত, এটি ব্যক্তিগত লক্ষ্য এবং উচ্চাকাঙ্ক্ষার বিষয়, যা প্রতিটি ব্যক্তির জন্য অনন্য। আপনি যদি মনে করেন যে একটি ফাঁক বছর আপনাকে বড় হতে, বিশ্ব দেখতে এবং আপনার ভবিষ্যতের অধ্যয়নের জন্য আপনাকে আরও ভালভাবে প্রস্তুত করতে সাহায্য করতে পারে, তবে এটির জন্য যান এবং অন্য কাউকে আপনাকে বলতে দেবেন না!
                                            </p>
                                        </>
                                }

                            </div>


                        </div>


                        <ReactPrint trigger={() => <button className='print:hidden ml-1 hover:scale-105 mt-28 mb-16 px-6 py-2 bg-green-600 text-white'>
                            <div className='text-[16px] text-white flex justify-start items-center gap-x-1'>
                                <BsFileEarmarkPdf size={25} className='text-white'></BsFileEarmarkPdf>
                                {
                                    language === 'english' ?
                                        <p>Download PDF</p>
                                        :
                                        <p>ডাউনলোড পিডিএফ</p>
                                }
                            </div>
                        </button>} content={() => ref.current}>
                        </ReactPrint>


                        {
                            language === 'english' ?
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>Share This Post</h1>
                                :
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>পোস্টটি শেয়ার করুন</h1>
                        }
                        <div className='print:hidden flex justify-start items-center'>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Facebook'>
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Facebook'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <FacebookIcon size={38} round={true} />
                                </FacebookShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Twitter'>
                                <TwitterShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Twitter'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <TwitterIcon size={38} round={true} />
                                </TwitterShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on LinkedIn'>
                                <LinkedinShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on LinkedIn'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <LinkedinIcon size={38} round={true} />
                                </LinkedinShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on WhatsApp'>
                                <WhatsappShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on WhatsApp'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <WhatsappIcon size={38} round={true} />
                                </WhatsappShareButton>
                            </div>
                        </div>


                    </div>








                </div>







                <div className='print:hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1 '>
                    <div className='lg:right-auto lg:fixed lg:top-[160px] lg:mr-10 relative'>
                        <div className={`bg-gray-700 rounded-sm px-3 pt-2 pb-3`}>
                            <p className='text-white text-center text-lg -mt-1 px-6 py-1'>Read More Blogs... </p>

                            <div>

                                <Link to='/blog3'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={studyAbroad} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>Why Study Abroad? Stories From International Students</p>
                                    </div>
                                </Link>

                                <Link to='/blog2'>
                                    <div className='hover:border-blue-500  cursor-pointer gap-x-3 mb-2  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm1} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>Worst npm Packages you should not use</p>
                                    </div>
                                </Link>

                                <Link to='/blog1'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>7 Most Popular Animation Libraries For React</p>
                                    </div>
                                </Link>

                                <Link to='/blog7'>
                                    <div className=' hover:border-blue-500 cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={resume} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px]  text-md '>How To Improve Your Resume In 9 Steps</p>
                                    </div>
                                </Link>







                                {/* <div className=' -mt-12 lg:w-[300px] md:w-[680px] sm:w-[350px] w-[350px]  '>
                                    <Swiper
                                        pagination={{
                                            clickable: true
                                        }}
                                        modules={[Pagination, Autoplay, Navigation]}
                                        autoplay={{ delay: 2000 }}
                                        className="mySwiper"
                                    >

                                        <SwiperSlide className=''>
                                            <div>
                                                <Link to='/blog4'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={visa} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                                    </div>
                                                </Link>
                                                <Link to='/blog2'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px]  cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={npm1} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 underline'>Worst npm Packages you should not use</p>
                                                    </div>
                                                </Link>

                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide className=''>
                                            <div>

                                                <Link to='/blog1'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={npm} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 underline'>7 Most Popular Animation Libraries For React</p>
                                                    </div>
                                                </Link>

                                                <Link to='/blog7'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={resume} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>How To Improve Your Resume In 9 Steps</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div> */}




                            </div>
                        </div>
                    </div>
                </div>




            </div>



        </div>
    );
};

export default Blog5Details;